import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Store } from 'lucide-react';

interface MarketplaceCardProps {
  name: string;
  description: string;
  status: string;
  onConnect: () => void;
  isLoading?: boolean;
}

export const MarketplaceCard = ({ name, description }: MarketplaceCardProps) => (
  <Card className="relative overflow-hidden">
    <CardHeader><CardTitle className="flex items-center gap-2"><Store className="h-5 w-5" />{name}</CardTitle></CardHeader>
    <CardContent>
      <p className="text-muted-foreground mb-4">{description}</p>
      <Button variant="outline" disabled className="w-full">Bientôt disponible</Button>
      <NotifyMeButton channel={name} className="w-full mt-2" />
    </CardContent>
  </Card>
);
